export const knollBurgundy = {
  600: '#3b010f',
  500: '#610219',
  50: '#f7b5c5'
};

export const knollGold = {
  500: '#ffd868'
};

export const knollGray = {
  main: '#333333',
  body: '#333333',
  light: '#F6F5F5',
  disabled: '#D7D7D7'
};

export const success = {
  500: '#439B18',
  100: '#DEF5D2',
  50: '#F4FEEF'
};

export const knollRed = {
  500: '#FF3535',
  100: '#FFD7D7',
  50: '#FFF5F5'
};

export const knollYellow = {
  500: '#FF9900',
  100: '#FFF3B3',
  50: '#FFFAE0'
};

export const knollBlue = {
  500: '#3368FF',
  50: '#F5F8FF'
};

export const white = '#FFFFFF';

export const black = '#000';
